module.exports = __webpack_public_path__ + "img/pic_zb_d1.01fa0d1f.png";